import {
  Component,
  ViewEncapsulation,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1203Model } from './kymw1203.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetOrderListService } from '../../../commons/kymw02/api-services/get-order-list.service';
import { KYMW1203InputModel } from './vo/kymw1203-input.model';
import { KYMW1203OutputModel } from './vo/kymw1203-output.model';

/**
 * 一括設定を管理するクラス
 *
 * @export KYMW1203Component
 * @class KYMW1203Component
 */
@Component({
  selector: 'app-kymw1203',
  templateUrl: 'kymw1203.component.html',
  styleUrls: ['kymw1203.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1203Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  public model: KYMW1203Model = new KYMW1203Model();

  // 価格パターン
  public readonly PRICE_PATTERN_LIST = [
    { Code: '', Name: '&nbsp;' },
    { Code: '0', Name: '&#9675;' },
    { Code: '1', Name: '&#9651;' },
    { Code: '2', Name: '&#9633;' },
    { Code: '3', Name: '&#9734;' },
    { Code: '9', Name: '&minus;' },
  ];

  // 設定間隔
  public readonly SETTING_SPAN_LIST = [
    { Code: '0', Name: '毎週' },
    { Code: '1', Name: '隔週' },
    { Code: '2', Name: '中３週' },
  ];

  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getOrderListService: GetOrderListService
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW1203Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1203';

    // 初期値
    this.model.pricePattern = this.PRICE_PATTERN_LIST[0].Code;
    this.model.settingSpan = this.SETTING_SPAN_LIST[0].Code;
    this.getOrderListService.execute(this.model, 'orderCodeList', () => {});
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW1203Component
   */
  public ngAfterViewInit(): void {}

  /**
   * ボタン押下 設定
   *
   * @memberof KYMW1203Component
   */
  public set() {
    if (!this.model.endOrder) this.model.endOrder = this.model.orderCodeFrom;
    const arr = this.model.filteredOrderCodeList
      .filter(_ => this.model.endOrder >= _.OrderCode)
      .filter((_, i) => {
        if (this.SETTING_SPAN_LIST[0].Code === this.model.settingSpan) {
          // 毎週
          return true;
        } else if (this.SETTING_SPAN_LIST[1].Code === this.model.settingSpan) {
          // 隔週
          return i % 2 === 0;
        } else if (this.SETTING_SPAN_LIST[2].Code === this.model.settingSpan) {
          // 中3週 (4週おき)
          return i % 4 === 0;
        }
      })
      .map(_ => _.OrderCode);
    this.model.out = {
      mediumType: this.model.mediumType,
      pcode: this.model.pcode,
      pricePattern: this.model.pricePattern,
      orderCodeList: arr,
    };
    this.closeFunction();
  }

  // 受注コード ⇒ 企画回
  public orderChange() {
    const val = this.model.orderCodeList.find(
      _ => this.model.endOrder === _.OrderCode
    )?.CatalogID;
    if (val) this.model.endCatalog = val;
  }

  // 企画回 ⇒ 受注コード
  public catalogChange() {
    const val = this.model.orderCodeList.find(
      _ => this.model.endCatalog === _.CatalogID
    )?.OrderCode;
    if (val) this.model.endOrder = val;
  }

  /**
   * パラメータ格納 呼び出し側から利用
   *
   * @memberof KYMW1203Component
   */
  setParams(a: KYMW1203InputModel) {
    this.model.mediumType = a.mediumType;
    this.model.pcode = a.pcode;
    this.model.orderCodeFrom = a.orderCodeFrom;
    this.model.orderCodeTo = a.orderCodeTo;
  }

  /**
   * パラメータ取得 呼び出し側から利用
   *
   */
  getParams(): KYMW1203OutputModel {
    return this.model.out;
  }
}
